export function judgeUserAgent(type) {
  var ua = navigator.userAgent.toLowerCase()
  const t = {
    weChat: 'micromessenger' //微信
  }

  var isWeixin = ua.indexOf(t[type]) != -1
  // if (!isWeixin) {
  //   Toast('请在微信登录')
  // }
  return isWeixin
}